var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_86)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_86",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 26,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999634 1.00092H25.0008V19.0009H0.999634V1.00092Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_86)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999878 1.00089H25.0046V19.0009H0.999878V1.00089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62976 6.46799L6.12656 2.72419L6.75053 3.14033L4.25373 6.88412L3.62976 6.46799ZM4.56571 7.09219L7.06251 3.34839L7.68648 3.76453L5.18968 7.50832L4.56571 7.09219ZM5.50166 7.71639L7.99846 3.97259L8.62242 4.38873L6.12562 8.13252L5.50166 7.71639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3568 15.6229L19.8536 11.8791L20.4776 12.2952L17.9808 16.039L17.3568 15.6229ZM18.2928 16.2471L20.7896 12.5033L21.4135 12.9194L18.9167 16.6632L18.2928 16.2471ZM19.2287 16.8713L21.7255 13.1275L22.3495 13.5436L19.8527 17.2874L19.2287 16.8713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2936 13.5429L21.4134 15.6236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2936 13.5429L21.4134 15.6236",
    stroke: "white",
    strokeWidth: 0.375
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24597 7.50903C9.90816 6.51612 10.9377 5.82692 12.108 5.59307C13.2783 5.35921 14.4937 5.59985 15.4866 6.26204C16.4795 6.92423 17.1687 7.95374 17.4025 9.12408C17.6364 10.2944 17.3958 11.5097 16.7336 12.5026L9.24597 7.50903Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24595 7.50901C8.58375 8.50193 8.34312 9.71723 8.57697 10.8876C8.81083 12.0579 9.50002 13.0874 10.4929 13.7496C11.4859 14.4118 12.7012 14.6524 13.8715 14.4186C15.0418 14.1847 16.0713 13.4955 16.7335 12.5026C17.0646 12.0062 17.185 11.3985 17.068 10.8133C16.9511 10.2282 16.6065 9.71341 16.11 9.38232C15.6136 9.05122 15.0059 8.9309 14.4208 9.04783C13.8356 9.16476 13.3208 9.50936 12.9897 10.0058L9.24595 7.50901Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9898 10.0059C13.6792 8.97209 13.4001 7.57509 12.3663 6.88562C11.3324 6.19614 9.93543 6.47529 9.24596 7.50911C8.55649 8.54293 8.83564 9.93994 9.86946 10.6294C10.9033 11.3189 12.3003 11.0397 12.9898 10.0059Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13684 17.2887L3.64004 13.5449L4.26401 13.1288L6.76081 16.8725L6.13684 17.2887ZM7.07279 16.6645L4.57599 12.9207L5.19995 12.5046L7.69676 16.2483L7.07279 16.6645ZM8.00874 16.0403L5.51194 12.2965L6.1359 11.8804L8.6327 15.6241L8.00874 16.0403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8644 8.13385L17.3676 4.39006L17.9915 3.97392L20.4883 7.71772L19.8644 8.13385ZM20.8003 7.50965L18.3035 3.76585L18.9275 3.34972L21.4243 7.09352L20.8003 7.50965ZM21.7363 6.88545L19.2395 3.14165L19.8634 2.72552L22.3602 6.46932L21.7363 6.88545Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66858 14.8967L6.60453 14.2725ZM18.3039 6.46996L19.3958 5.74173ZM20.3318 5.11753L21.2677 4.49333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66858 14.8967L6.60453 14.2725M18.3039 6.46996L19.3958 5.74173M20.3318 5.11753L21.2677 4.49333",
    stroke: "white",
    strokeWidth: 0.375
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8125,
    y: 0.8125,
    width: 24.375,
    height: 18.375,
    stroke: "#E8E8E8",
    strokeWidth: 0.375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorea);
export default __webpack_public_path__ + "static/media/korea.e6179f2365cec37ba9a31504af51e13b.svg";
export { ForwardRef as ReactComponent };